import React from "react"
// import { Typography } from "@material-ui/core"

// import ContentContainer from "../../components/ContentContainer"
import DocumentsLists from "./DocumentsLists"
import DocumentsHeader from "../../components/DocumentsHeader"
import Layout from "../../components/AuthenticatedLayout"
import TabsNav from "../../components/TabsNav"

const documentsItems = [
  {
    title: "Meeting Minutes",
    content: <DocumentsLists documentsType="MEETING" />,
  },
  {
    title: "Budgets",
    content: <DocumentsLists documentsType="BUDGET" />,
  },
  {
    title: "Financial",
    content: <DocumentsLists documentsType="FINANCIAL" />,
  },
  {
    title: "Bylaws & Declarations",
    content: <DocumentsLists documentsType="BYLAW" />,
  },
  {
    title: "Rules & Regulations",
    content: <DocumentsLists documentsType="RULE" />,
  },
]

const Documents = () => {
  return (
    <Layout title="Documents">
      <TabsNav items={documentsItems} header={<DocumentsHeader />} style={{ zIndex: 1000 }} />
    </Layout>
  )
}

export default Documents
